<div class="row justify-content-around">
  <div class="col-11 col-sm-10">
    <mat-card class="col-12  primary-color">
      <h1 class="col-12"><b>{{ 'RECHARGE.AVANTAGE.TITLE' | translate }}</b></h1>
      <div class="col-12">
        <div class="row justify-content-around">
          <div class="col-md-3 col-12">
            <div class="row info-content justify-content-around  ">
              <div class="col-11">
                <img src="../../../assets/img/Recharge/Avantages/PictoRecharge_Tranquille.svg" alt="">
                <h3 class="bold">
                  {{ 'RECHARGE.AVANTAGE.TITLE1' | translate }}
                </h3>
                <h5>
                  {{ 'RECHARGE.AVANTAGE.PARA1' | translate }}
                </h5>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-12">
            <div class="row info-content justify-content-around  ">
              <div class="col-11">
                <img src="../../../assets/img/Recharge/Avantages/PictoRecharge_CarteStation.svg" alt="">
                <h3 class="bold">
                  {{ 'RECHARGE.AVANTAGE.TITLE2' | translate }}
                </h3>
                <h5>
                  {{ 'RECHARGE.AVANTAGE.PARA2' | translate }}
                </h5>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-12">
            <div class="row info-content justify-content-around  ">
              <div class="col-11">
                <img src="../../../assets/img/Recharge/Avantages/PictoAutopartage_Telephone.svg" alt="">
                <h3 class="bold">
                  {{ 'RECHARGE.AVANTAGE.TITLE3' | translate }}
                </h3>
                <h5>
                  {{ 'RECHARGE.AVANTAGE.PARA3' | translate }}
                </h5>
              </div>
            </div>
          </div>


        </div>
      </div>
    </mat-card>
  </div>
</div>

